// extracted by mini-css-extract-plugin
export default {"wrap":"EJ-z","heading":"FJ-z"};